<template>
 <div class="invoice-wrapper">
   <div class="header">
    <el-row :gutter="8">
      <el-form ref="form" :model="form" label-width="80px">
        <el-col :span="6" v-if="activeTab === 2">
          <el-form-item label="开票日期">
            <el-date-picker
              v-model="form.date"
              type="daterange"
              align="right"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              unlink-panels
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              :picker-options="pickerOptions">
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="结算单号">
            <el-input v-model="form.settleNo" placeholder="可输入结算单号查询"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-button type="primary" @click="onSubmit" class="btn">搜索</el-button>
          <el-button class="btn default-btn" @click="resetData">重置</el-button>
        </el-col>
      </el-form>
    </el-row>
   </div>
   <div class="table-wrapper">
     <div class="tabs">
        <span class="tab" :class="{'active-tab': activeTab === 1}" @click="goToBillList(1)">待开票</span>
        <span class="tab" :class="{'active-tab': activeTab === 2}" @click="goToBillList(2)">已开票</span>
     </div>
     <el-dropdown trigger="click" size="medium" placement="bottom" class="batchbtn m-r-10">
       <el-button type="primary" size="small">
         批量操作
         <i class="el-icon-caret-bottom el-icon--right"></i>
       </el-button>
       <el-dropdown-menu slot="dropdown">
         <el-dropdown-item @click.native="exportData(1)" v-if="activeTab === 1">批量开票</el-dropdown-item>
         <el-dropdown-item @click.native="exportData(2, 'batch')">导出明细</el-dropdown-item>
         <el-dropdown-item @click.native="exportData(3)" v-if="activeTab === 2">导出结算单明细</el-dropdown-item>
       </el-dropdown-menu>
     </el-dropdown>
     <!-- 待开票表格-->
     <div v-show="activeTab === 1">
       <!-- 表格-->
       <el-table
         v-loading="loading"
         :data="unInvoiceTableData"
         tooltip-effect="dark"
         :max-height="300"
         style="width: 100%"
         @selection-change="handleSelectionChange">
         <el-table-column
           type="selection"
           width="55">
         </el-table-column>
         <el-table-column
           label="序号"
           prop="serialNum"
         >
         </el-table-column>
         <el-table-column
           prop="title"
           label="发票抬头"
         >
         </el-table-column>
         <el-table-column
           prop="settleNo"
           label="结算单号"
         >
           <template slot-scope="scope">
             <span @click="loadSettleItemList(scope.row.settleNo, 'receiptNo')" class="receipt-no">{{scope.row.settleNo}}</span>
           </template>
         </el-table-column>
         <el-table-column
           prop="purchaseTotalAmount"
           label="采购总金额"
         >
         </el-table-column>
         <el-table-column
           prop="refundTotalAmount"
           label="退货总金额"
         >
         </el-table-column>
         <el-table-column
           fixed="right"
           label="操作"
         >
           <template slot-scope="scope">
             <el-button
               @click.native.prevent="goInvoice([scope.row.settleNo], scope.row)"
               type="text"
               size="small">
               去开票
             </el-button>
           </template>
         </el-table-column>
       </el-table>
     </div>
     <!-- 已开票表格-->
     <div v-show="activeTab === 2">
       <!-- 表格-->
       <el-table
         v-loading="loading"
         :data="invoiceData"
         style="width: 100%"
         :max-height="400"
         row-key="serialNum"
         @selection-change="handleSelectionChange"
         @expand-change="expandSelect"
       >
         <el-table-column
           type="selection"
           width="55">
         </el-table-column>
         <el-table-column
           type="expand"
           width="55"
         >
           <template slot-scope="props">
             <!--内嵌表格-->
             <el-table :data="props.row.child">
               <el-table-column
                 label="序号"
                 prop="serialNum"
               >
               </el-table-column>
               <el-table-column
                 label="结算单号"
                 prop="settleNo"
               >
               </el-table-column>
               <el-table-column
                 label="销售单号/售后单号"
                 prop="saleOrder"
               >
               </el-table-column>
               <el-table-column
                 label="商品编码"
                 prop="skuCode"
               >
               </el-table-column>
               <el-table-column
                 label="商品名称"
                 prop="skuName"
               >
               </el-table-column>
               <el-table-column
                 label="采购数量"
                 prop="purchaseQuantity"
               >
               </el-table-column>
               <el-table-column
                 label="采购单价"
                 prop="purchasePrice"
               >
               </el-table-column>
               <el-table-column
                 label="采购总额/采退总额"
                 prop="purchaseAmount"
               >
               </el-table-column>
             </el-table>
             <!-- 分页 -->
             <el-pagination
               @size-change="(val) => handleSizeChange(val,'detail')"
               @current-change="(val) => handleCurrentChange(val,'detail')"
               :current-page="detailCurrentPage"
               :page-sizes="[10, 50, 100, 200]"
               :page-size.sync="detailPageSize"
               layout="total, sizes, prev, pager, next, jumper"
               :total="detailTotalCount"
             ></el-pagination>
           </template>
         </el-table-column>
         <el-table-column
           label="序号"
           width="120"
           prop="serialNum"
         >
         </el-table-column>
         <el-table-column
           prop="receiptNo"
           label="发票号"
           width="120"
         >
           <template slot-scope="scope">
             <span @click="bigImg(scope.row.receiptNo, 'receiptNo')" class="receipt-no">{{scope.row.receiptNo}}</span>
           </template>
         </el-table-column>
         <el-table-column
           prop="title"
           label="发票抬头"
           width="120"
         >
         </el-table-column>
         <el-table-column
           prop="billDate"
           label="开票日期"
         >
         </el-table-column>
         <el-table-column
           prop="purchaseTotalAmount"
           label="采购总金额"
           width="120">
         </el-table-column>
         <el-table-column
           prop="returnTotalAmount"
           label="退货总金额"
           width="120">
         </el-table-column>
         <el-table-column
           prop="invoiceAmount"
           label="篮字发票金额"
           width="120">
           <template slot-scope="scope">
             <span style="color: #2196FF">{{scope.row.invoiceAmount}}</span>
           </template>
         </el-table-column>
         <el-table-column
           prop="redFlushAmount"
           label="红字发票金额"
           width="120">
           <template slot-scope="scope">
             <span style="color: #FF4726">{{scope.row.redFlushAmount}}</span>
           </template>
         </el-table-column>
         <el-table-column
           prop="deliveryCompany"
           label="快递公司"
           width="120">
         </el-table-column>
         <el-table-column
           prop="deliveryNumber"
           label="快递单号"
           width="120">
           <template slot-scope="scope">
             <span @click="bigImg(scope.row.deliveryNumber, 'deliveryNumber')" class="receipt-no">{{scope.row.deliveryNumber}}</span>
           </template>
         </el-table-column>
       </el-table>
     </div>
     <!-- 分页 -->
     <el-pagination
       @size-change="handleSizeChange"
       @current-change="handleCurrentChange"
       :current-page="currentPage"
       :page-sizes="[10, 50, 100, 200]"
       :page-size.sync="pageSize"
       layout="total, sizes, prev, pager, next, jumper"
       :total="totalCount"
     ></el-pagination>
     <div class="detail" v-if="activeTab === 1">
       <div class="detail-title">发票详情：</div>
       <!-- 发票详情表格-->
       <el-table
         :data="detailData"
         v-loading="detailLoading"
         tooltip-effect="dark"
         style="width: 100%">
         <el-table-column
           label="序号"
           prop="serialNum"
         >
         </el-table-column>
         <el-table-column
           prop="salesOrderNo"
           label="销售单号/售后单号"
         >
         </el-table-column>
         <el-table-column
           prop="skuCode"
           label="商品编码">
         </el-table-column>
         <el-table-column
           prop="skuName"
           label="商品名称"
         >
         </el-table-column>
         <el-table-column
           prop="purchaseQuantity"
           label="采购数量"
         >
         </el-table-column>
         <el-table-column
           prop="purchasePrice"
           label="采购单价"
         >
         </el-table-column>
         <el-table-column
           prop="purchaseAmount"
           label="采购金额/采退金额"
         >
         </el-table-column>
       </el-table>
     </div>
     <!-- 开票明细弹窗-->
     <el-dialog
       class="settle-modal"
       :visible.sync="dialogVisible"
       width="80%"
       :append-to-body="true"
       @close="handleBtn('cancel1')">
       <span slot="title" class="dialog-title">
        <span class="title">开票明细</span>
         <span class="sub-title">(弹窗中的明细为选中的待开票列表，更多信息请点击导出明细按钮)</span>
      </span>
       <span slot="footer" class="dialog-footer">
<!--        <el-button type="default" class="btn" @click="exportData(2)">导出明细</el-button>-->
        <el-button type="primary" @click="handleBtn('next')">下一步({{this.selectKeys.length || 1}}条)</el-button>
      </span>
       <!--红蓝分开-->
       <el-table
         :data="invoiceInfo.splitInvoiceItem"
         border
         height="200"
         show-summary
         sum-text="小计"
         v-if="invoiceInfo.splitInvoiceItem && invoiceInfo.splitInvoiceItem.length > 0"
         style="width: 100%; margin-top: 20px">
         <el-table-column
           type="index"
           label="序号"
           width="180">
         </el-table-column>
         <el-table-column
           prop="settleNo"
           label="结算单号">
         </el-table-column>
         <el-table-column
           prop="purchaseAmount"
           label="采购总金额">
         </el-table-column>
         <el-table-column
           prop="refundAmount"
           label="退货总金额">
         </el-table-column>
       </el-table>
       <el-row class='num' v-if="invoiceInfo.splitInvoiceItem && invoiceInfo.splitInvoiceItem.length > 0">
         <el-col :span="12">
           <span class="label">待开增值税发票(篮字)：</span>
           <span class="blue">¥{{invoiceInfo.invoiceAmount}}</span>
         </el-col>
         <el-col :span="12">
           <span class="label">待开增值税发票(红字)：</span>
           <span class="red">¥{{invoiceInfo.redFlushAmount}}</span>
         </el-col>
       </el-row>
       <!--红蓝相抵-->
       <el-table
         :data="invoiceInfo.deductInvoiceItem"
         border
         height="200"
         v-if="invoiceInfo.deductInvoiceItem && invoiceInfo.deductInvoiceItem.length > 0"
         style="width: 100%; margin-top: 20px">
         <el-table-column
           type="index"
           label="序号">
         </el-table-column>
         <el-table-column
           prop="title"
           label="发票抬头"
           width="180">
         </el-table-column>
         <el-table-column
           prop="settleNo"
           label="结算单号">
         </el-table-column>
         <el-table-column
           prop="saleOrder"
           label="销售单号/售后单号"
           width="180"
         >
         </el-table-column>
         <el-table-column
           prop="skuCode"
           label="商品编码">
         </el-table-column>
         <el-table-column
           prop="skuName"
           label="商品名称">
         </el-table-column>
         <el-table-column
           prop="purchaseQuantity"
           label="采购数量">
         </el-table-column>
         <el-table-column
           prop="purchasePrice"
           label="采购单价">
         </el-table-column>
         <el-table-column
           prop="purchaseAmount"
           label="采购金额/采退金额"
           width="180"
         >
         </el-table-column>
       </el-table>
       <el-row class='num' v-if="invoiceInfo.deductInvoiceItem && invoiceInfo.deductInvoiceItem.length > 0">
         <el-col :span="1">
           <span class="label">合计：</span>
         </el-col>
         <el-col :span="5">
           <span class="label">采购总金额：¥{{invoiceInfo.purchaseTotalAmount}}</span>
         </el-col>
         <el-col :span="5">
           <span class="label">退货总金额：-¥{{invoiceInfo.refundTotalAmount}}</span>
         </el-col>
         <el-col :span="6">
           <span class="label">待开增值税发票(篮字)：</span>
           <span class="blue">¥{{invoiceInfo.invoiceAmount}}</span>
         </el-col>
         <el-col :span="5">
           <span class="label">待开增值税发票(红字)：</span>
           <span class="red">¥{{invoiceInfo.redFlushAmount}}</span>
         </el-col>
       </el-row>
     </el-dialog>
     <!-- 开票明细第二步弹窗 width: 30% 单个-->
     <el-dialog
       class="settle-modal"
       :visible.sync="dialogVisible2"
       :width="(invoiceInfo.redFlushAmount < 0 && invoiceInfo.invoiceAmount > 0) ? '60%' : '32%'"
       :append-to-body="true"
       @close="handleBtn('cancel2')">
       <span slot="title" class="dialog-title">
        <span class="title">开票明细</span>
         <span class="sub-title" style="color: #FF9D0C">(发票号必须填写正确，提交后无法修改)</span>
      </span>
       <span slot="footer" class="dialog-footer">
           <el-button class="btn" @click="handleBtn('cancel2')">取消</el-button>
           <el-button type="primary" @click="submitBill">提交</el-button>
      </span>
       <div class="form-wrapper">
         <el-row :gutter="30">
           <el-col :span="(invoiceInfo.redFlushAmount < 0 && invoiceInfo.invoiceAmount > 0) ? 12 : 24" v-if="invoiceInfo.invoiceAmount">
             <div class="line">
               <span class="label">发票类型</span>
               <span class="value">增值税发票</span>
             </div>
             <div class="line">
               <span class="label">篮字发票金额</span>
               <span class="value">¥{{invoiceInfo.invoiceAmount}}</span>
             </div>
             <div class="line bill" v-for="(item, index) in blueBillingList">
               <span class="label"><span class="red">*</span>开票号</span>
               <el-input v-model="item.num" placeholder="请输入开票号" style="width: 87%"></el-input>
               <i class="el-icon-circle-plus-outline" @click="addBill('blue', 'add')" v-if="index===0"></i>
               <i class="el-icon-remove-outline" @click="addBill('blue', 'remove', item.id)" v-if="index !== 0"></i>
             </div>
             <div class="line">
               <span class="label"><span class="red">*</span>开票日期</span>
               <el-date-picker
                 v-model="modalData.blueDate"
                 format="yyyy-MM-dd"
                 value-format="yyyy-MM-dd"
                 type="date"
                 class="invoice-date"
                 style="width: 85%"
                 placeholder="请选择开票日期">
               </el-date-picker>
             </div>
             <div>
               <div class="label m-b-10"><span class="red">*</span>上传发票图片</div>
               <div>
                 <el-upload
                   :action="uploadUrl"
                   list-type="picture-card"
                   :headers="headers"
                   :on-preview="(file) => handlePictureCardPreview(file,'blue')"
                   :on-remove="(file, fileList) => handleRemove(file, fileList,'blue')"
                   :on-change="(file, fileList) => changeImage(file, fileList,'blue')"
                   :on-success="(response, file, fileList) => handleSuccess(response, file, fileList,'blue')"
                   :on-error="(file, fileList) => handleError(file, fileList,'blue')"
                   :file-list="blueFileList"
                   :before-upload="beforeAvatarUpload"
                   :multiple="true"
                   name="files"
                 >
                   <i class="el-icon-plus"></i>
                 </el-upload>
                 <el-dialog :visible.sync="blueDialogImgVisible" :append-to-body="true">
                   <img width="100%" :src="blueDialogImageUrl" alt="">
                 </el-dialog>
               </div>
             </div>
           </el-col>
           <el-col :span="(invoiceInfo.redFlushAmount < 0 && invoiceInfo.invoiceAmount > 0) ? 12 : 24" v-if="invoiceInfo.redFlushAmount">
             <div class="line">
               <span class="label">发票类型</span>
               <span class="value">增值税发票</span>
             </div>
             <div class="line">
               <span class="label">红字发票金额</span>
               <span class="value">¥{{invoiceInfo.redFlushAmount}}</span>
             </div>
             <div class="line bill" v-for="(item, index) in redBillingList">
               <span class="label"> <span class="red">*</span>开票号</span>
               <el-input v-model="item.num" placeholder="请输入开票号" style="width: 87%"></el-input>
               <i class="el-icon-circle-plus-outline" @click="addBill('red', 'add')" v-if="index===0"></i>
               <i class="el-icon-remove-outline" @click="addBill('red', 'remove', item.id)" v-if="index !== 0"></i>
             </div>
             <div class="line">
               <span class="label"> <span class="red">*</span> 开票日期</span>
               <el-date-picker
                 v-model="modalData.redDate"
                 format="yyyy-MM-dd"
                 value-format="yyyy-MM-dd"
                 type="date"
                 class="invoice-date"
                 style="width: 83%"
                 placeholder="请选择开票日期">
               </el-date-picker>
             </div>
             <div>
               <div class="label m-b-10"> <span class="red">*</span>上传发票图片</div>
               <div>
                 <el-upload
                   :action="uploadUrl"
                   list-type="picture-card"
                   :headers="headers"
                   :on-preview="(file) => handlePictureCardPreview(file,'red')"
                   :on-remove="(file, fileList) => handleRemove(file, fileList,'red')"
                   :on-change="(file, fileList) => changeImage(file, fileList,'red')"
                   :on-success="(response, file, fileList) => handleSuccess(response, file, fileList,'red')"
                   :on-error="(file, fileList) => handleError(file, fileList,'red')"
                   :file-list="redFileList"
                   :before-upload="beforeAvatarUpload"
                   :multiple="true"
                   name="files"
                 >
                   <i class="el-icon-plus"></i>
                 </el-upload>
                 <el-dialog :visible.sync="redDialogImgVisible">
                   <img width="100%" :src="redDialogImageUrl" alt="">
                 </el-dialog>
               </div>
             </div>
           </el-col>
         </el-row>
         <div class="line delivery">
           <span class="label"><span class="red">*</span>快递公司</span>
           <el-input v-model="modalData.deliveryCompany" placeholder="请输入快递公司" style="width: 85%"></el-input>
         </div>
         <div class="line">
           <span class="label"><span class="red">*</span>快递单号</span>
           <el-input v-model="modalData.deliveryNo" placeholder="请输入快递单号" style="width: 85%"></el-input>
         </div>
         <div>
           <div class="label m-b-10"><span class="red">*</span>上传快递图片</div>
           <div>
             <el-upload
               :action="uploadUrl"
               list-type="picture-card"
               :headers="headers"
               :on-preview="(file) => handlePictureCardPreview(file,'delivery')"
               :on-remove="(file, fileList) => handleRemove(file, fileList,'delivery')"
               :on-change="(file, fileList) => changeImage(file, fileList,'delivery')"
               :on-success="(response, file, fileList) => handleSuccess(response, file, fileList,'delivery')"
               :on-error="(file, fileList) => handleError(file, fileList,'delivery')"
               :file-list="deliveryFileList"
               :auto-upload="true"
               :class="{ disabled: deliveryFileList.length > 0}"
               :before-upload="beforeAvatarUpload"
               name="files"
             >
               <i class="el-icon-plus"></i>
             </el-upload>
             <el-dialog :visible.sync="deliveryDialogImgVisible" :append-to-body="true">
               <img width="100%" :src="deliveryDialogImageUrl" alt="">
             </el-dialog>
           </div>
         </div>
       </div>
     </el-dialog>
     <!-- 对账管理-查看原单弹窗-->
     <el-dialog
       class="settle-modal"
       :visible.sync="accountDialogVisible"
       width="80%"
       :append-to-body="true"
     >
       <span slot="title" class="dialog-title">
        <span class="title">查看原单</span>
      </span>
       <span slot="footer" class="dialog-footer">
        <el-button type="primary">确认</el-button>
      </span>
       <el-table
         :data="tableData"
         border
         height="100"
         style="width: 100%; margin-top: 20px">
         <el-table-column
           prop="id"
           label="原单"
           width="180">
         </el-table-column>
         <el-table-column
           prop="name"
           label="售后确认日期">
         </el-table-column>
         <el-table-column
           prop="name"
           label="售后单号">
         </el-table-column>
         <el-table-column
           prop="amount1"
           label="商品编码">
         </el-table-column>
         <el-table-column
           prop="amount2"
           label="商品名称">
         </el-table-column>
         <el-table-column
           prop="amount3"
           label="售后确认数量">
         </el-table-column>
         <el-table-column
           prop="amount3"
           label="采购单价">
         </el-table-column>
         <el-table-column
           prop="amount3"
           label="售后总额">
         </el-table-column>
       </el-table>
       <el-table
         :data="tableData"
         border
         height="100"
         style="width: 100%; margin-top: 20px">
         <el-table-column
           prop="id"
           label="暂未抵扣"
           width="180">
         </el-table-column>
         <el-table-column
           prop="name"
           label="订单状态">
         </el-table-column>
         <el-table-column
           prop="amount1"
         >
         </el-table-column>
         <el-table-column
           prop="amount1"
         >
         </el-table-column>
         <el-table-column
           prop="amount2"
         >
         </el-table-column>
         <el-table-column
           prop="amount3"
           label="剩余扣款数量">
         </el-table-column>
         <el-table-column
           prop="amount3"
           label="采购单价">
         </el-table-column>
         <el-table-column
           prop="amount3"
           label="剩余扣款总额">
         </el-table-column>
       </el-table>
       <el-table
         :data="tableData"
         border
         height="100"
         style="width: 100%; margin-top: 20px">
         <el-table-column
           prop="id"
           label="已抵扣"
           width="180">
         </el-table-column>
         <el-table-column
           prop="name"
           label="订单状态">
         </el-table-column>
         <el-table-column
           prop="amount1"
           label="结算单">
         </el-table-column>
         <el-table-column
           prop="amount2"
         >
         </el-table-column>
         <el-table-column
           prop="amount2"
         >
         </el-table-column>
         <el-table-column
           prop="amount3"
           label="扣款数量">
         </el-table-column>
         <el-table-column
           prop="amount3"
           label="采购单价">
         </el-table-column>
         <el-table-column
           prop="amount3"
           label="扣款总额">
         </el-table-column>
       </el-table>
     </el-dialog>
     <viewer :images="imgList"
             @inited="inited"
             class="viewer" ref="viewer">
       <img hidden v-for="src in imgList" :src="src" :key="src">
     </viewer>
   </div>
 </div>
</template>
<script>
import 'viewerjs/dist/viewer.css'
import Viewer from "v-viewer/src/component.vue"
import {
  loadInvoiceImage, queryDeliveryImage, queryInvoice, queryInvoiceItemInfo,
  queryInvoiceItemList,
  queryInvoiceList, querySettleItemList,
  queryUnInvoiceList
} from "../../models/r4InvoiceModel";
import {map} from "lodash";
import r4InvoiceApiList from "../../service/basic/r4InvoiceApiList";
import {buildURL} from "../../utils/utils";

export default {
  components: {
    "viewer": Viewer
  },
  data() {
    return {
      loading: false,
      detailLoading: false,
      headers: {
        Authorization: localStorage.getItem('token'),
      },
      uploadUrl: myhostname + r4InvoiceApiList.getImage,
      unInvoiceTableData: [],
      imgList: [],
      invoiceDetailData: [],
      invoiceData: [],
      blueBillingList: [{num: '', id: 0}],
      redBillingList: [{num: '',  id: 0}],
      reason: '',
      blueFileList: [],
      blueDialogImageUrl: '',
      blueDialogImgVisible: false,
      redFileList: [],
      redDialogImageUrl: '',
      redDialogImgVisible: false,
      deliveryFileList: [],
      deliveryDialogImageUrl: '',
      deliveryDialogImgVisible: false,
      accountDialogVisible: false,
      dialogVisible: false,
      dialogVisible2: false,
      billDialog: false,
      appealDialog: false,
      tableData: [{name: 'uuuu'}],
      detailData: [],
      currentPage: 1,
      pageSize: 10,
      totalCount: 0,
      detailCurrentPage: 1,
      detailPageSize: 10,
      detailTotalCount: 0,
      pickerOptions: {
        shortcuts: [
          {
          text: '最近一周',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近三个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          }
        }]
      },
      form: {
        date: '',
        settleNo: '',
        saleOrder: ''
      },
      selectKeys:[],
      modalData: {
        num: '',
        date: '',
        company: undefined,
        deliveryCompany: '',
        deliveryNo: '',
        blueDate: '',
        redDate: '',
      },
      options: [],
      activeTab: 1,
      invoiceInfo: {
        splitInvoiceItem: [],
        deductInvoiceItem: [],
        invoiceAmount: 10,
        purchaseTotalAmount: 0,
        redFlushAmount: 10,
        refundTotalAmount: 0,
      },
      singleItem: null,
      expandKeys: [], // 主要看这，指定展开的行
    };
  },
  created() {

  },
  mounted() {
    this.loadUnInvoiceList();
  },
  methods: {
    // 待开票列表
    loadUnInvoiceList() {
      this.loading = true;
      queryUnInvoiceList({
        pageIndex: this.currentPage - 1,
        pageSize: this.pageSize,
        channel: 4,
        supplierId: localStorage.getItem('supplier_id'),
        billDateStart: this.form.date ? this.form.date[0] + ' 00:00:00' : '',
        billDateEnd: this.form.date ? this.form.date[1] + ' 23:59:59' : '',
        saleOrder: this.form.saleOrder,
        settleNo: this.form.settleNo,
      }).then(res => {
        this.loading = false;
        this.unInvoiceTableData = res ? res.content.map((item, index) => {
          item.serialNum = index + 1 + (this.currentPage - 1) * this.pageSize;
          return item;
        }) : []
        this.totalCount = res ? Number(res.totalElements) : 0;
      }).catch((err) => {
        console.log(err);
        this.loading = false;
        this.$message.error(err.message);
      });
    },
    // 已开票列表
    loadInvoiceList() {
      this.loading = true;
      queryInvoiceList({
        pageIndex: this.currentPage - 1,
        pageSize: this.pageSize,
        channel: 4,
        supplierId: localStorage.getItem('supplier_id'),
        billDateStart: this.form.date ? this.form.date[0] + ' 00:00:00' : '',
        billDateEnd: this.form.date ? this.form.date[1] + ' 23:59:59' : '',
        saleOrder: this.form.saleOrder,
        settleNo: this.form.settleNo,
      }).then(res => {
        this.loading = false;
        this.invoiceData = res ? res.content.map((item, index) => {
          item.serialNum = index + 1 + (this.currentPage - 1) * this.pageSize;
          item.child = [] // 先给一个空值
          item.expand = false  // 表示当前行是闭合的，不设置这个等下展开后就没法闭合了
          return item;
        }) : []
        this.totalCount = res ? Number(res.totalElements) : 0;
      }).catch((err) => {
        console.log(err);
        this.loading = false;
        this.$message.error(err.message);
      });
    },
    // 已开票明细列表
    loadInvoiceItemList(receiptId, row) {
      this.loading = true;
      queryInvoiceItemList({
        pageIndex: this.currentPage - 1,
        pageSize: this.pageSize,
        receiptId,
        supplierId: localStorage.getItem('supplier_id'),
      }).then(res => {
        console.log(res, "res");
        this.loading = false;
        row.expand = true // 设置展开行是打开的
        row.child = res ? res.content.map((item, index) => {
          item.serialNum = index + 1 + (this.detailCurrentPage - 1) * this.detailPageSize;
          this.expandKeys.push(item.serialNum); // 把该行的id 给expandKeys
          return item;
        }) : []
        console.log(this.invoiceDetailData, "invoiceDetailData");
        this.detailTotalCount = res ? Number(res.totalElements) : 0;
      }).catch((err) => {
        console.log(err);
        this.loading = false;
        this.$message.error(err.message);
      });
    },
    // 生成发票
    loadInvoice() {
      let settleIdList = [];
      if (this.singleItem) { // 单个开票
        settleIdList = [this.singleItem.settleId];
      } else {// 批量
        settleIdList = map(this.selectKeys, 'settleId');
      }
      const reqList = [];
      if (this.invoiceInfo.invoiceAmount > 0) { // 蓝字金额有值
        const receiptNos = map(this.blueBillingList, "num");
        console.log(receiptNos, "receiptNos");
        if(!receiptNos[0]) {
          this.$message.error("请填写蓝字发票开票号");
          return;
        }
        if(!this.modalData.blueDate) {
          this.$message.error("请选择蓝字发票开票日期");
          return;
        }
        if(this.blueFileList && this.blueFileList.length === 0) {
          this.$message.error("请上传蓝字发票图片");
          return;
        }
        reqList.push({
          billDate: this.modalData.blueDate + " 00:00:00",
          deliveryCompany: this.modalData.deliveryCompany,
          supplierId: localStorage.getItem('supplier_id'),
          deliveryImg: this.deliveryFileList[0],
          deliveryNo: this.modalData.deliveryNo,
          invoiceAmount: this.modalData.invoiceAmount,
          invoiceImg: this.blueFileList,
          invoiceType: 1, // 1 蓝票 2红票,
          receiptNo: receiptNos.join(','),
          settleIds: settleIdList,
        })
      }

      if (this.invoiceInfo.redFlushAmount < 0) { // 红字金额有值
        const receiptNos = map(this.redBillingList, "num");
        if(receiptNos && receiptNos.length === 0) {
          this.$message.error("请填写红字发票开票号");
          return;
        }
        if(!this.modalData.redDate) {
          this.$message.error("请选择红字发票开票日期");
          return;
        }
        if(this.redFileList && this.redFileList.length === 0) {
          this.$message.error("请上传红字发票图片");
          return;
        }
        reqList.push({
          billDate: this.modalData.redDate + " 00:00:00",
          deliveryCompany: this.modalData.deliveryCompany,
          supplierId: localStorage.getItem('supplier_id'),
          deliveryImg: this.deliveryFileList[0],
          deliveryNo: this.modalData.deliveryNo,
          invoiceAmount: this.modalData.invoiceAmount,
          invoiceImg: this.redFileList,
          invoiceType: 2, // 1 蓝票 2红票,
          receiptNo: receiptNos.join(','),
          settleIds: settleIdList
        })
      }
      if(!this.modalData.deliveryCompany) {
        this.$message.error("请填写快递公司");
        return;
      }
      if(!this.modalData.deliveryNo) {
        this.$message.error("请填写快递单号");
        return;
      }
      if(!this.deliveryFileList[0]) {
        this.$message.error("请上传快递图片");
        return;
      }
      queryInvoice({reqList}).then(res => {
        console.log(res, "res");
        if (res.code === 200) {
          this.dialogVisible = false;
          this.dialogVisible2 = false;
          this.currentPage = 1;
          this.pageSize = 10;
          this.loadUnInvoiceList();
        }
      }).catch((err) => {
        console.log(err);
        this.$message.error(err.message);
      });
    },
    // 结算单明细列表
    loadSettleItemList(settleNo) {
      this.detailLoading = true;
      querySettleItemList({
        settleNo,
      }).then(res => {
        this.detailLoading = false;
        this.detailData = res ? res.map((item, index) => {
          item.serialNum = index + 1;
          return item;
        }) : []
      }).catch((err) => {
        console.log(err);
        this.detailLoading = false;
        this.$message.error(err.message);
      });
    },
    // 开票明细
    loadInvoiceItemInfo(settleNo) {
      queryInvoiceItemInfo({
        settleNo: settleNo.length > 0 ? settleNo.join(',') : '',
      }).then(res => {
        this.invoiceInfo = res;
        if (res.deductInvoiceItem.length === 0 && res.splitInvoiceItem.length === 0) { // 单个明细
          this.dialogVisible2 = true;
        } else {
          this.dialogVisible = true;
        }
      }).catch((err) => {
        console.log(err);
        this.$message.error(err.message);
      });
    },
    // 开票
    goInvoice(settleNo, record) {
      this.singleItem = record;
      this.loadInvoiceItemInfo(settleNo);
    },
    inited(viewer) {
      this.$viewer = viewer
    },
    // 查看发票
    bigImg(no, type){
      if (type === 'receiptNo') {
        loadInvoiceImage({receiptNo: no}).then(res => {
          this.imgList = res.split(',') || []
          this.$viewer.show()
        })
      } else {
        queryDeliveryImage({deliveryNumber: no}).then(res => {
          this.imgList = res.split(',') || []
          this.$viewer.show()
        })
      }
    },
    expandSelect(row, expandedRows) {
      if (!row.expand) {  // 先判断该行是否已经展开了
        this.loadInvoiceItemList(row.receiptId, row);
      } else {
        row.expand = false;
      }
    },
    goToBillList(type) {
      this.activeTab = type;
      this.form = {
        date: '',
        settleNo: '',
        saleOrder: ''
      }
      this.currentPage = 1;
      this.pageSize = 10;
      this.detailCurrentPage = 1;
      this.detailPageSize = 10;
      if(this.activeTab === 1) {
        this.loadUnInvoiceList()
      } else {
        this.loadInvoiceList();
      }
    },
    submitBill() {
      this.loadInvoice();
    },
    addBill(type, opt, id) {
      if(type === 'blue') {
        if (opt === 'add') {
          this.blueBillingList.push({
            num: '',
            id: this.blueBillingList.length
          });
        } else {
          const index = this.blueBillingList.findIndex((item) => item.id === id)
          console.log(index, "index");
          this.blueBillingList.splice(index, 1);
          console.log(this.blueBillingList, "this.blueBillingList");
        }
      } else {
        if (opt === 'add') {
          this.redBillingList.push({
            num: '',
            id: this.redBillingList.length
          });
        } else {
          const index = this.redBillingList.findIndex((item) => item.id === id)
          console.log(index, "index");
          this.redBillingList.splice(index, 1);
          console.log(this.redBillingList, "this.redBillingList");
        }
      }
    },
    beforeAvatarUpload(file) {
      const isJPG = (file.type === 'image/jpeg' || file.type === 'image/jpg' || file.type === 'image/png');
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isJPG) {
        this.$message.error('上传图片只能是 jpg/png 格式!');
      }
      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 2MB!');
      }
      return isJPG && isLt2M;
    },
    handleSuccess(response, file, fileList, type) {
      console.log("file",response, file, fileList, type);
      switch (type) {
        case 'blue':
          this.blueFileList.push(response.data[0]);
          break;
        case 'red':
          this.redFileList.push(response.data[0]);
          break;
        case 'delivery':
          this.deliveryFileList.push(response.data[0]);
          break;
      }
      this.$message({
        message: '上传成功！',
        type: 'success'
      });
    },
    handleError(err, file, fileList) {
      this.$message({
        message: '上传失败！',
        type: 'error'
      });
      console.log(err);
    },
    exce() {
      this.$message.warning("最多上传1张图片");
    },
    changeImage(file, fileList, type) {
      console.log(file, fileList);
    },
    handleRemove(file, fileList, type) {
      console.log(file, fileList);
      switch (type) {
        case 'blue':
          const currentBlueUrl = file.response.data[0];
          const blueIndex = this.blueFileList.findIndex((url) => url === currentBlueUrl);
          this.blueFileList.splice(blueIndex, 1);
          break;
        case 'red':
          const currentRedUrl = file.response.data[0];
          const redIndex = this.redFileList.findIndex((url) => url === currentRedUrl);
          this.redFileList.splice(redIndex, 1);
          break;
        case 'delivery':
          const currentDeliveryUrl = file.response.data[0];
          const deliveryIndex = this.deliveryFileList.findIndex((url) => url === currentDeliveryUrl);
          this.deliveryFileList.splice(deliveryIndex, 1);
          break;
      }
    },
    handlePictureCardPreview(file, type) {
      switch (type) {
        case 'blue':
          this.blueDialogImageUrl = file.url;
          this.blueDialogImgVisible = true;
          break;
        case 'red':
          this.redDialogImageUrl = file.url;
          this.redDialogImgVisible = true;
          break;
        case 'delivery':
          this.deliveryDialogImageUrl = file.url;
          this.deliveryDialogImgVisible = true;
          break;
      }
    },
    handleBtn(type) {
      switch (type) {
        case 'cancel1':
          this.dialogVisible = false;
          break;
        case 'next':
          this.dialogVisible2 = true;
          this.modalData = {
            num: '',
            date: '',
            company: undefined,
            deliveryCompany: '',
            deliveryNo: '',
            blueDate: '',
            redDate: '',
          }
          this.blueBillingList = [{num: ''}];
          this.redBillingList = [{num: ''}];
          this.blueFileList = [];
          this.redFileList = [];
          break;
        case 'cancel2':
          this.dialogVisible2 = false;
          break;
      }
    },
    // 每页条数改变
    handleSizeChange(val, type) {
      switch (type) {
        case 'detail':
          this.detailPageSize = val;
          this.loadInvoiceItemList();
          break;
        default:
          this.pageSize = val;
          if(this.activeTab === 1) {
            this.loadUnInvoiceList()
          } else {
            this.loadInvoiceList()
          }
          break;
      }
    },
    // 页码改变
    handleCurrentChange(val, type) {
      console.log(val, "page");
      switch (type) {
        case 'detail':
          this.detailCurrentPage = val;
          this.loadInvoiceItemList();
          break;
        default:
          this.currentPage = val;
          if(this.activeTab === 1) {
            this.loadUnInvoiceList()
          } else {
            this.loadInvoiceList()
          }
          break;
      }
    },
    onSubmit() {
      console.log(this.form, "submit");
      this.currentPage = 1;
      this.pageSize = 10;
      if(this.activeTab === 1) {
        this.loadUnInvoiceList()
      } else {
        this.loadInvoiceList();
      }
    },
    resetData() {
      this.form = {
        date: '',
        settleNo: '',
        saleOrder: ''
      }
      this.currentPage = 1;
      this.pageSize = 10;
      this.detailCurrentPage = 1;
      this.detailPageSize = 10;
      if(this.activeTab === 1) {
        this.loadUnInvoiceList()
      } else {
        this.loadInvoiceList();
      }
    },
    exportData(type, btnName) {
      if(type === 1) { // 批量开票
        if (this.selectKeys && this.selectKeys.length === 0) {
          this.$message.info('请先勾选数据');
          return;
        }
        const settleNoList = map(this.selectKeys, 'settleNo');
        this.goInvoice(settleNoList)
      } else if (type === 2) { // 发票明细
        console.log(this.selectKeys, "this.selectKeys", this.singleItem); // todo 争艳
        if (this.activeTab === 1) { // 待开票
          let settleNoList = null;
          if ((btnName === 'batch')) { // 批量
            if(this.selectKeys && this.selectKeys.length === 0) {
              this.$message.error("请先勾选数据");
              return;
            }
            settleNoList = map(this.selectKeys, 'settleNo').join(',');
          } else {
            settleNoList = this.singleItem.settleNo;
          }
          window.open(myhostname + r4InvoiceApiList.exportUnInvoice + "?shop_id="+ localStorage.getItem('shop_id') + "&settleNo="+ settleNoList +"&access_token=" + localStorage.getItem('token'));
        } else {// 已开票
          const params = {
            pageIndex: this.currentPage - 1,
            pageSize: this.pageSize,
            channel: 4,
            supplierId: localStorage.getItem('supplier_id'),
            billDateStart: this.form.date ? this.form.date[0] + ' 00:00:00' : '',
            billDateEnd: this.form.date ? this.form.date[1] + ' 23:59:59' : '',
            saleOrder: this.form.saleOrder,
            settleNo: this.form.settleNo,
          }
          window.open(`${myhostname}${ r4InvoiceApiList.exportInvoice}?${buildURL(params)}&access_token=${localStorage.getItem('token')}`);
        }
      } else { // 结算单明细
        const params = {
          pageIndex: this.currentPage - 1,
          pageSize: this.pageSize,
          channel: 4,
          supplierId: localStorage.getItem('supplier_id'),
          billDateStart: this.form.date ? this.form.date[0] + ' 00:00:00' : '',
          billDateEnd: this.form.date ? this.form.date[1] + ' 23:59:59' : '',
          settleNo: this.form.settleNo,
        }
        window.open(`${myhostname}${ r4InvoiceApiList.exportInvoiceItem}?${buildURL(params)}&access_token=${localStorage.getItem('token')}`);
      }
    },
    handleSelectionChange(val) {
      console.log(val, "898998");
      this.selectKeys = val;
    }
  },
};
</script>
<style lang="scss">
.invoice-wrapper {
  width: 100%;
  height: auto;
  padding: 12px 0;
  background: #fff;

  .btn {
    width: 70px;
    height: 30px;
    background: linear-gradient(132deg, #FF602F 0%, #FF3722 100%, #FF3621 100%, #FF3621 100%, #FF3722 100%);
    border-radius: 6px;
    font-size: 8px;
    font-family: MicrosoftYaHei;
    color: #FFFFFF;
    padding: 0;
    line-height: 30px;
    margin-top: 5px;
  }

  .default-btn {
    background: #fff;
    font-size: 8px;
    font-family: MicrosoftYaHei;
    color: #666666;
    border-radius: 6px;
    border: 1px solid #D5D5D5;
  }

  .batchbtn {
    float: right;
    margin-bottom: 8px;
  }

  .tabs {
    float: left;
    margin-top: 8px;
    >span:first-child {
      border-radius: 4px 0px 0px 0px;
    }
    > span:last-child {
      border-radius: 0px 4px 0px 0px;
      margin-left: -5px;
    }
  }
  .tab {
    width: 60px;
    height: 22px;
    background: #73818C;
    color: #fff;
    padding: 6px 18px;
    cursor: pointer;
  }
  .active-tab {
    background: #A4B4C1;
  }
  .detail-title {
    font-size: 12px;
    font-family: SourceHanSansCN-Bold, SourceHanSansCN;
    font-weight: bold;
    color: #333333;
    margin-bottom: 6px;
  }
  .el-range-editor.el-input__inner {
    width: 100%;
  }
  .demo-table-expand {
    font-size: 0;
  }
  .demo-table-expand label {
    width: 90px;
    color: #99a9bf;
  }
  .receipt-no {
    color: #236BDC;
    cursor: pointer;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/settlementManage/invoice.vue